import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "antd/dist/reset.css";
import "index.css";
import "assets/css/custom.css";
import dayjs from "dayjs";
import "dayjs/locale/id";
import * as Sentry from "@sentry/react";

dayjs.locale("id");

// Sentry.init({
//   dsn: "https://e309a01efbb05850d4d5bb94f7c19fe0@o4507152549806080.ingest.us.sentry.io/4507152551444480",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: [
//     "https://api-staging.kitrans.web.id/",
//     "https://kitrans.web.id/",
//   ],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

// Firebase Messaging service worker didaftarkan dari jalur FCM,
// jadi CRA service worker default tidak dipakai di sini.
